/* Editorial video. Product detail images use the click-and-pan interaction in main-product.liquid. */
(() => {
  class CampaignFilm extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = reduced.matches;
      let visible = false;
      const update = () => {
        button.textContent = video.paused ? 'Play film' : 'Pause film';
        button.setAttribute('aria-label', video.paused ? 'Play campaign video' : 'Pause campaign video');
      };
      const sync = () => {
        if (!visible || document.hidden || userPaused) video.pause();
        else video.play().catch(update);
      };
      video.muted = true;
      video.addEventListener('play', update, options);
      video.addEventListener('pause', update, options);
      button.addEventListener('click', () => { userPaused = !video.paused; sync(); }, options);
      document.addEventListener('visibilitychange', sync, options);
      reduced.addEventListener('change', () => { userPaused = reduced.matches; sync(); }, options);
      this.observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: .15 });
      this.observer.observe(this);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.querySelector('video')?.pause(); }
  }
  if (!customElements.get('campaign-film')) customElements.define('campaign-film', CampaignFilm);
})();
